import { observable, action } from 'mobx';
import { message } from 'antd';
import base from '../../tool/base';
import util from '../../util/index';
const { catchApiError, getAccessToken } = util;
export class OrderStore {
  @observable orderDatas = [];
  @observable loadingOrder = false;
  @observable addModal = {
    addWhere: "0",
    visible: false,
    title: "",
    datas: [],
    cloumns: []
  }

  @observable applyModal = {
    visible: false,
    title: "获取表单",
  }

  @observable routes = [];
  @observable pagination = {
    defaultCurrent: 1,
    total: 0,
    current: 1,
    showSizeChanger: true,
    showQuickJumper: true,
    pageSize: 10,
  }
  @observable searchValue = {
    appName: '',
    startDate: null,
    endDate: null
  }
  @observable propertyList = [];

  constructor(routing) {
    this.routing = routing;
    this.setPagination = this.setPagination.bind(this);
    this.getRoutes = this.getRoutes.bind(this);
    this.callOrderData = this.callOrderData.bind(this);
    this.setApplyModal = this.setApplyModal.bind(this);
  }

  @action

  setApplyModal(params = {}) {
    this.applyModal = { ...this.applyModal, ...params };
  }
  addModal(params = {}) {
    this.addModal = { ...this.addModal, params };
  }
  callOrderData(params = {}) {
    this.loadingOrder = true;
    params.access_token = getAccessToken();
    params.pageSize = this.pagination.pageSize;
    params = { ...this.searchValue, ...this.pagination, ...params };
    base.callApi('/v3/order/get', 'POST', params, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
      if (data.status === 'true') {
        let temp = data.list || [];
        temp.forEach(item => {
          item.selected = false;
          item.hasMore = item.swList.length > 10;
          item.current = 1;
          item.pageSize = 10;
        });
        this.orderDatas = temp;
        this.pagination = { ...this.pagination, total: data.count };
      } else {
        message.info(data.msg);
      }
      this.loadingOrder = false;
    });
  }

  setPagination(pagination) {
    this.pagination = pagination;
  }

  getRoutes(params) {
    this.routes = [{
      key: '1',
      breadcrumbName: '云商店',
      path: '/'
    }];
    if (params.id && params.id === 'all') {
      this.routes.push({
        key: '2',
        breadcrumbName: '全部应用',
        path: '/app/list'
      });
    } else if (params.id && params.id === 'workflow') {
      this.routes.push({
        key: '2',
        breadcrumbName: '流程表单',
        path: '/app/list'
      });
    } else if (params.id && params.id === 'portal') {
      this.routes.push({
        key: '2',
        breadcrumbName: '门户应用',
        path: '/app/list'
      });
    }
    this.routes.push({
      key: '3',
      breadcrumbName: '我的订单',
      path: '/app/order'
    });
  }

  @action
  getPropertyList = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v5/ecode/propertyList', 'GET', param, 'json', 'text').then(action((data) => catchApiError(data, this.routing))).then(action((data) => {
        if (data.status) {
          const res = data.data.filter((da) => da.key !== '0'); // 过滤选项：‘全部’
          res.forEach((re) => {
            re.key = re.g_id;
            re.name = re.g_name || res.name;
          })
          this.propertyList = res;
          resolve(res);
        } else {
          message.error(data.msg);
        }
        resolve([]);
      }));
    }); 
  }
}


// WEBPACK FOOTER //
// ./src/stores/order/OrderStore.js